import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Home } from './components/pages/Home';
import { MyOrgPage } from './components/pages/MyOrgPage';
import { ToolsPage } from './components/pages/ToolsPage';
import { ReportsPage } from './components/pages/ReportsPage';
// import {PerksPage} from './components/pages/PerksPage';
// import {TeamsPage} from './components/pages/TeamsPage';
// import {TeamDetails} from './components/Teams/TeamDetails';
// import {ExpensesPage} from './components/pages/ExpensesPage';
import MySuperPage from './components/pages/MySuperPage';
import { SettingsPage } from './components/pages/SettingsPage';
import { FaqPage } from './components/pages/FaqPage';
// import {AddPerksToProgramPage} from './components/pages/AddPerksToProgramPage';
// import {EmployeesPage} from './components/pages/EmployeesPage';
// import {EmployeeDetails} from './components/Employees/EmployeeDetails';
import { AppState } from './context/app/AppState';
import { LoginPage } from './components/pages/LoginPage';
import { PrivateRoute } from "./components/routing/PrivateRoute";
import { CreatePasswordPage } from "./components/pages/CreatePasswordPage";
// import {AddExpensesToProgramPage} from './components/Expenses/AddExpensesToProgramPage';
import { ProgramsPage } from './components/pages/ProgramsPage';
import { LoginRedirectPage } from './components/pages/LoginRedirectPage';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import {OnboardingIntegrationAdmin} from "./components/pages/OnboardingIntegrationAdmin"

/*import {Dimmer, Loader} from "semantic-ui-react";

const loader = (
    <Dimmer active>
        <Loader />
    </Dimmer>
)*/

function App() {
    const [userInfo, setUserInfo] = useState(null);
    return (
        <div id="app">
            <AppState>
                <Router>
                    <Switch>
                        {/* TODO: Should be sub-route or keep maintaining here? */}
                        <PrivateRoute exact path="/account" component={MyOrgPage} />
                        <PrivateRoute exact path="/super" component={MySuperPage} />
                        <Route path="/create-password/:orgToken" component={CreatePasswordPage} />
                        <Route exact path="/login"><LoginPage /></Route>
                        <Route exact path="/login-redirect-google"><LoginRedirectPage setUserInfo={setUserInfo} /></Route>
                        <Route exact path="/login-redirect-microsoft"><LoginRedirectPage setUserInfo={setUserInfo} /></Route>
                        <Route exact path="/login-redirect-okta"><LoginRedirectPage setUserInfo={setUserInfo} /></Route>

                        <PrivateRoute exact path="/account/payment-setup" component={MyOrgPage} />
                        <PrivateRoute exact path="/account/invoices" component={MyOrgPage} />

                        <Route exact path="/onboarding/admin/:type/:orgId" component={OnboardingIntegrationAdmin} />

                        <PrivateRoute exact path="/programs" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/teams/:id" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/employees" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/employees/:id" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/perk-programs" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/perk-programs/active" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/perk-programs/expired" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/perk-programs/:id/add-perks" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/expense-programs" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/expense-programs/active" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/expense-programs/expired" component={ProgramsPage} />
                        <PrivateRoute exact path="/programs/expense-programs/:id/add-expenses" component={ProgramsPage} />

                        <PrivateRoute exact path="/tools" component={ToolsPage} />
                        <PrivateRoute exact path="/analytics" component={ReportsPage} />

                        <PrivateRoute exact path="/settings" component={SettingsPage} />
                        <PrivateRoute exact path="/settings/integrations" component={SettingsPage} />
                        <PrivateRoute exact path="/settings/physical-cards" component={SettingsPage} />
                        <PrivateRoute exact path="/settings/user-settings" component={SettingsPage} />
                        <PrivateRoute exact path="/settings/notifications" component={SettingsPage} />
                        <PrivateRoute exact path="/faq" component={FaqPage} />
                        <PrivateRoute exact path="/" component={Home} />
                        <PrivateRoute exact path="/home" component={Home} />
                        <PrivateRoute component={Home} />
                    </Switch>
                </Router>
            </AppState>
            <ToastContainer />
        </div>
    );
}

export default App;
